export default __webpack_public_path__ + "static/media/QS_Mobile.92643c8c.png";